<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Amortización de Crédito - Ver</strong>

            <router-link class="btn btn-light float-right btn-sm"  :to="{ path: '/amortizacion-credito/listar' }" append ><i class="fa fa-chevron-left"></i> Regresar</router-link>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" autocomplete="off">
              <b-row>

                <b-col lg="6">
                  <b-form-group>
                    <label>Crédito:</label>
                    <v-select disabled placeholder="Seleccione un crédito" class="w-100" :filterable="false" label="text" v-model="credit"></v-select>
                  </b-form-group>
                </b-col>
                
                <b-col md="2">
                  <b-form-group label="Codigo:">
                    <b-form-input disabled class="text-center" type="text" v-model="credit_amortization.code"></b-form-input>
                  </b-form-group>
                </b-col>


                <b-col md="2">
                  <b-form-group label="Medio de pago:">
                    <b-form-select disabled v-model="credit_amortization.payment_method" :options="payment_method"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Fecha:">
                    <b-form-input disabled type="date" class="text-center" v-model="credit_amortization.date"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Nro Cuota:">
                    <b-form-input disabled type="text" class="text-center" v-model="credit_amortization.quota_number"></b-form-input>
                  </b-form-group>
                </b-col>

  
                <b-col md="2">
                  <b-form-group label="Saldo Capital:">
                    <b-form-input disabled type="number" step="any" class="text-right" v-model="credit_amortization.balance"></b-form-input>
                  </b-form-group>
                </b-col>

          

                <b-col md="2">
                  <b-form-group label="Total:">
                    <b-form-input disabled type="number" step="any" class="text-right" v-model="credit_amortization.total"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label=".">
                    <b-button :disabled="credit_amortization.annexes == ''" type="button" variant="warning" @click="OpenAnnexes" class="form-control">Ver Documento Adjunto</b-button>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group label="Remplazar Doc. Adjunto:">
                    <b-form-file disabled accept="application/pdf"  v-model="file"  placeholder="Selecciona un archivo" drop-placeholder="Arrastre el archivo aqui"></b-form-file>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group label="Observación:">
                    <b-form-textarea disabled v-model="credit_amortization.observation"></b-form-textarea>
                  </b-form-group>
                </b-col>

   
                <b-col md="12" >
                  <div class="alert alert-dark" role="alert">
                    <strong>CRONOGRAMA DE ṔAGO</strong> 
                  </div>
                </b-col>

                <b-col md="12">
                  <div class="table-responsive">
                    <table class="table table-hover table-bordered">
                      <thead>
                        <tr>
                          <th width="3%" class="text-center">#</th>
                          <th width="9%" class="text-center">Fecha</th>
                          <th width="7%" class="text-center">Cuota</th>
                          <th width="7%" class="text-center">Amortización</th>
                          <th width="7%" class="text-center">Capital</th>
                          <th width="7%" class="text-center">Interes</th>
                          <th width="7%" class="text-center">Saldo <br> Capital </th>
                          
                      
                        </tr>
                      </thead>
                      <tbody v-for="(item, it) in credit_amortization.credits_details" :key="it">
                        <tr>
                          <td class="text-center">{{ item.quota_number }}</td>
                          <td class="text-center"> {{ item.date  }}</td>
                          <td class="text-right"> {{ item.quota  }}</td>
                          <td class="text-right"> {{ item.amortization  }}</td>
                          <td class="text-right"> {{ item.capital_balance  }}</td>
                          <td class="text-right"> {{ item.interest  }}</td>
                          <td class="text-right"> {{ item.balance  }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
            
               
                <b-col md="5"></b-col>
                <b-col md="2">
                  <b-button class="form-control" @click="OpenVoucher" type="button" variant="warning">Imprimir Recibo</b-button>
                </b-col>
      
                
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>


    <ModalClients />
    <LoadingComponent :is-visible="isLoading"/>

  </div>
</template>

<script>

import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";


const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
var moment = require("moment");

import { mapState,mapMutations,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";
import DataCollection from "@/assets/js/DataCollection";
// components
import ModalClients from './../components/ModalClient'
import LoadingComponent from './../pages/Loading'
export default {
  name: "CreditPaymentAdd",
  props: ["id_credit_amortization"],
  components:{
      vSelect,
      ModalClients,
      Keypress: () => import('vue-keypress'),
      LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'CreditAmortization',
      role: 5,
      credit_amortization: {
          id_credit_amortization:'',
          id_client:'',
          id_user:'',
          id_branch_office:'',
          id_credit:'',
          id_credit_detail:'',
          code:'',
          payment_method:'008',
          date:moment(new Date()).local().format("YYYY-MM-DD"),
          annexes:'',
          annexes_change:'',
          observation:'',
          quota:'0.00',
          amortization:'0.00',
          total:'0.00',
          state:1,
          quota_number : '',
          balance : '',
          interest : '',
          credits_details : [],
          credits_details_agricultural : [],
          capital_diference:'0.00',
      },
      file:null,
      modules:[],
      // payment_method:[
      //   {value:'008', text:'EFECTIVO'},
      //   {value:'007', text:'CHEQUES'},
      //   {value:'001', text:'DEPÓSITO EN CUENTA'},
      //   {value:'003', text:'TRANSFERENCIA DE FONDOS'},
      // ],
      credit: null,
      errors: {
        id_client: false,
        payment_method: false,
        date: false,
        total: false,
        id_credit:false,
        id_credit_detail: false,
      },
      validate: false,
    };
  },
  mounted() {
    this.ViewCreditAmortization();
  },
  methods: {
    ViewCreditAmortization,
    OpenAnnexes,
    OpenVoucher,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    },
    payment_method: function () {
      return DataCollection.MethodPayment();
    }
  },
};

function OpenAnnexes() {
  let me = this;
  let url = me.url_base + this.credit_amortization.annexes;
  window.open(url,'_blank');
}

function ViewCreditAmortization() {
  let me = this;
  let id_credit_amortization = je.decrypt(this.id_credit_amortization);
  let url = me.url_base + "credit-amortization/view/"+id_credit_amortization;

  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.credit = { value: response.data.result.credit_amortization.id_credit, text: response.data.result.credit_amortization.credit};

        
        me.credit_amortization.id_credit_amortization = response.data.result.credit_amortization.id_credit_amortization;
        me.credit_amortization.code = response.data.result.credit_amortization.code;
        me.credit_amortization.payment_method = response.data.result.credit_amortization.payment_method;
        me.credit_amortization.observation = response.data.result.credit_amortization.observation;
        me.credit_amortization.date = response.data.result.credit_amortization.date;
        me.credit_amortization.annexes = response.data.result.credit_amortization.annexes;
        me.credit_amortization.quota = response.data.result.credit_amortization.quota;
        me.credit_amortization.amortization = response.data.result.credit_amortization.amortization;
        me.credit_amortization.total = response.data.result.credit_amortization.total;
        me.credit_amortization.quota_number = response.data.result.credit_amortization.quota_number;
        me.credit_amortization.balance = response.data.result.credit_amortization.balance;
        me.credit_amortization.credits_details = response.data.result.credit_amortizacion_detail;
      }
    });
}


function OpenVoucher() {
  let me = this;
  let url = me.url_base + "credit-amortization-sales-of-receip/"+ this.credit_amortization.id_credit_amortization;
  var ventana1 = window.open(url, '_blank');
}
</script>
